import { FormDialogTemplate } from "../../../../shared/form-dialog/form-dialog.template";
import { Injector } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";

const partNamePlaceholderText = 'Enter a Part Name';
const invalidPartNameText = 'Invalid Part Name';
const programNameText = 'Program Name';

export class PartListFormDialogTemplate extends FormDialogTemplate {
    constructor(private readonly injector: Injector) {
        super();
        const formBuilder: FormBuilder = this.injector.get(FormBuilder);

        this.editForm = formBuilder.group({
            Id: [],
            Name: ['', Validators.compose([Validators.required, Validators.maxLength(155)])],
            Type: [],
            Action: [],
            PlantName: [],
            PartCode: [],
            PartNumber: [],
            ProgramName: [],
            ContainerId: [],
            ContainerProject: [],
            PartType: [],
            SPM: [],
            Overall: [],
            NumberOfPeople: [],
            NumberOfTrucks: [],
        })
        this.initilize("Parts", this.editForm, this.formDialogTabs);

    }

    formControls = [
        {
            type: 'text',
            title: 'Part Name',
            name: 'Name',
            placeholder: partNamePlaceholderText,
            invalidText: invalidPartNameText,
            stretch: true,
        },
        {
            type: 'text',
            title: 'Plant Name',
            name: 'PlantName',
            placeholder: 'Enter a Plant Name',
            invalidText: 'Invalid Plant Name',
            stretch: true,
        },
        {
            type: 'text',
            title: 'Part Number',
            name: 'PartNumber',
            placeholder: 'Enter a Part Number',
            invalidText: 'Invalid Part Number',
            stretch: true,
        },
        {
            type: 'text',
            title: 'Part Number',
            name: 'PartNumber',
            placeholder: 'Enter a Part Number',
            invalidText: 'Invalid Part Number',
            stretch: true,
        },
        {
            type: 'text',
            title: programNameText,
            name: 'ProgramName',
            placeholder: 'Enter a Program Name',
            invalidText: 'Invalid Program Name',
            stretch: true,
        },
        {
            type: 'text',
            title: programNameText,
            name: 'ProgramName',
            placeholder: partNamePlaceholderText,
            invalidText: invalidPartNameText,
            stretch: true,
        },
        {
            type: 'text',
            title: programNameText,
            name: 'ProgramName',
            placeholder: partNamePlaceholderText,
            invalidText: invalidPartNameText,
            stretch: true,
        },
        {
            type: 'text',
            title: programNameText,
            name: 'ProgramName',
            placeholder: partNamePlaceholderText,
            invalidText: invalidPartNameText,
            stretch: true,
        },
        {
            type: 'text',
            title: programNameText,
            name: 'ProgramName',
            placeholder: partNamePlaceholderText,
            invalidText: invalidPartNameText,
            stretch: true,
        },
        {
            type: 'text',
            title: programNameText,
            name: 'ProgramName',
            placeholder: partNamePlaceholderText,
            invalidText: invalidPartNameText,
            stretch: true,
        },
        {
            type: 'text',
            title: programNameText,
            name: 'ProgramName',
            placeholder: partNamePlaceholderText,
            invalidText: invalidPartNameText,
            stretch: true,
        },
        {
            type: 'text',
            title: programNameText,
            name: 'ProgramName',
            placeholder: partNamePlaceholderText,
            invalidText: invalidPartNameText,
            stretch: true,
        },
        {
            type: 'text',
            title: programNameText,
            name: 'ProgramName',
            placeholder: partNamePlaceholderText,
            invalidText: invalidPartNameText,
            stretch: true,
        },
    ]
    formDialogTabs = [
        {
            title: "Parts",
            selected: true,
            formControls: this.formControls,
        },
    ]
}
